import { config } from './config';

export function getKeycloakLoginUrl() {
  const { url, realm, clientId } = config.keycloak;
  const redirectUri = encodeURIComponent(config.frontendAppUrl);
  return `${url}/realms/${realm}/protocol/openid-connect/auth?client_id=${encodeURIComponent(clientId)}&redirect_uri=${redirectUri}&response_type=code&scope=openid`;
}

export function getDriverAppUrl() {
  if (config.driverAppUrl) return config.driverAppUrl;
  if (typeof window !== 'undefined') return `${window.location.origin}/driver`;
  return '/driver';
}
